import { render, staticRenderFns } from "./CambiarPassword.vue?vue&type=template&id=32b2d7b6&scoped=true&"
import script from "./CambiarPassword.vue?vue&type=script&lang=js&"
export * from "./CambiarPassword.vue?vue&type=script&lang=js&"
import style0 from "./CambiarPassword.vue?vue&type=style&index=0&id=32b2d7b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b2d7b6",
  null
  
)

export default component.exports